import { render, staticRenderFns } from "./CrearClienteProveedorModal.vue?vue&type=template&id=bd6ed8de&"
import script from "./CrearClienteProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./CrearClienteProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bd6ed8de', component.options)
    } else {
      api.reload('bd6ed8de', component.options)
    }
    module.hot.accept("./CrearClienteProveedorModal.vue?vue&type=template&id=bd6ed8de&", function () {
      api.rerender('bd6ed8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/CrearClienteProveedorModal.vue"
export default component.exports